module.exports = __webpack_public_path__ + "static/img/weixin.244e792e.png";